import React, { useEffect, useState } from 'react';
import api from '../services/api';
import UserMenu from '../components/UserMenu';
import AjustesMenu from '../components/AjustesMenu';
import { getUserFromStorage } from '../services/auth';


const TMDB_API_KEY = '0c867cfbfa47cf1e70b33a5eac501d4a';
const TMDB_BASE_URL = 'https://api.themoviedb.org/3';

const placeholderImage = 'https://media.istockphoto.com/id/1147544807/es/vector/no-imagen-en-miniatura-gr%C3%A1fico-vectorial.jpg?s=1024x1024&w=is&k=20&c=jMNMEtHs4WCgUd9WCoR2gcKdD0UAOFoTROlutZRWNLE=';

function PerfilNoticias() {
  const [itemsPerPage, setItemsPerPage] = useState(32);

  useEffect(() => {
    const user = getUserFromStorage();
    const servidor = user?.servidor || 'Desconocido';
    console.log('🧾 Servidor desde getUserFromStorage:', servidor);
  }, []);
  
  useEffect(() => {
  const calcularItemsPorPantalla = () => {
    const ancho = window.innerWidth;
    const alto = window.innerHeight;
    
    const columnas = ancho > 1400 ? 6 : ancho > 1100 ? 5 : ancho > 800 ? 4 : ancho > 600 ? 3 : 2;
    const filas = alto > 1000 ? 6 : alto > 800 ? 5 : alto > 600 ? 4 : 3;

    setItemsPerPage(columnas * filas);
  };

  calcularItemsPorPantalla(); // inicial
  window.addEventListener('resize', calcularItemsPorPantalla);
  return () => window.removeEventListener('resize', calcularItemsPorPantalla);
}, []);


  const [contenidos, setContenidos] = useState({
    ultimos: [],
    infantiles: [],
    masVistas: { peliculas: [], series: [] }
  });
  const [categoria, setCategoria] = useState('ultimos');
  const [subCategoriaRecientes, setSubCategoriaRecientes] = useState('peliculas');
  const [modalData, setModalData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [detallesCache, setDetallesCache] = useState({});
  const [usuario, setUsuario] = useState(null);
  const [paginaActual, setPaginaActual] = useState(1);
  const [hoveredCard, setHoveredCard] = useState(null);

  // Perfil guardado en localStorage (debe incluir user_id)
  const perfil = JSON.parse(localStorage.getItem('perfilActual'));

  const nombresServidores = {
    Mundiemby1: "MundiEmby 1",
    Mundiemby2: "MundiEmby 2",
    Mundiemby3: "MundiEmby 3",
    Mundiemby4: "MundiEmby 4",
    Mundiemby5: "MundiEmby 5",
    Mundiemby6: "MundiEmby 6",
    Mundiemby7: "MundiEmby 7",
  };

  const servidoresEmby = {
    Mundiemby1: { url: "http://mundiemby.us.to:33421", api_key: "241ac4cd1eb74a6b9218ffc5fdb5efcf" },
    Mundiemby2: { url: "http://mundiemby.us.to:33428", api_key: "e825b3f79022462490d0591ab45e7acb" },
    Mundiemby3: { url: "http://mundiemby.us.to:33423", api_key: "1536b2acc91043e189e83008956e22fb" },
    Mundiemby4: { url: "http://mundiemby.us.to:33426", api_key: "b2cd008a7f4d4ab780d29165d5bcf1ef" },
    Mundiemby5: { url: "http://mundiemby.us.to:33422", api_key: "8a05cb8dc0f7402991448ecf6511cc3d" },
    Mundiemby6: { url: "http://mundiemby.us.to:33424", api_key: "47b40611aa7c42db8b03ff4848346711" },
    Mundiemby7: { url: "http://mundiemby.us.to:33427", api_key: "10f90d322cae460f8c357586b1cde83b" }
  };

  // Mapeo de servidor a su serverId real
  const serverIds = {
    Mundiemby1: "fba973edcf2a42d7be059836e5f346d2",
    Mundiemby2: "dd5f69e25426401da9d6e07c9313774e",
    Mundiemby3: "8abdc39571c449a78c4eaee44084795f",
    Mundiemby4: "2fe0c8512f1145bfbda3cbb33f8e7c90",
    Mundiemby5: "afc5e2e2dec24e4a9242254332457041",
    Mundiemby6: "c0cee1433e17457ab9ae0d3c1ce7c32a",
    Mundiemby7: "e7084912b2a44eeaab24015c39f0ad6e"
  };

  // Obtener usuario completo para saber su servidor
  useEffect(() => {
    const cargarUsuario = async () => {
      if (!perfil?.user_id) return;
      try {
        const res = await api.get(`/usuarios/${perfil.user_id}`);
        setUsuario(res.data);
      } catch (error) {
        console.error('Error cargando usuario:', error);
      }
    };
    cargarUsuario();
  }, [perfil]);

  // Servidor real en minúsculas para filtrar y mostrar
  const servidorUsuario = getUserFromStorage()?.servidor || 'Mundiemby1';


  // Construye URL Emby para contenido, con serverId real
  const construirUrlEmby = (embyId, servidor) => {
    if (!embyId || !servidor) return '#';
    const servidorCapitalizado = Object.keys(servidoresEmby).find(
      key => key.toLowerCase() === servidor.toLowerCase()
    ) || 'Mundiemby1';
  
    const baseUrl = servidoresEmby[servidorCapitalizado]?.url;
    const serverIdReal = serverIds[servidorCapitalizado] || '';
    return `${baseUrl}/web/index.html#!/item?id=${embyId}&serverId=${serverIdReal}`;
  };
  
  

  const fetchDetallesTMDB = async (tmdbId, tipo) => {
    if (!tmdbId) return null;
    if (detallesCache[tmdbId]) return detallesCache[tmdbId];
    try {
      const res = await fetch(`${TMDB_BASE_URL}/${tipo === 'serie' ? 'tv' : 'movie'}/${tmdbId}?api_key=${TMDB_API_KEY}&language=es-ES&append_to_response=credits`);
      if (!res.ok) throw new Error('Error al obtener detalles de TMDB');
      const data = await res.json();
      setDetallesCache(prev => ({ ...prev, [tmdbId]: data }));
      return data;
    } catch (error) {
      console.error(error);
      return null;
    }
  };

  // Cargar contenidos según categoría y reset paginación si es "ultimos"
  useEffect(() => {
    const cargarContenidos = async () => {
      setLoading(true);
      setError(null);
      try {
        let response;
        if (categoria === 'ultimos') {
          response = await api.get(`/noticias/emby/${servidorUsuario.toLowerCase()}`);
          setContenidos(prev => ({ ...prev, ultimos: response.data }));
          setPaginaActual(1); // resetea página al cambiar a ultimos
        } else if (categoria === 'masVistas') {
          response = await api.get(`/noticias/emby/masvistos/${servidorUsuario.toLowerCase()}`);
          const peliculas = response.data.filter(c => c.tipo === 'pelicula');
          const series = response.data.filter(c => c.tipo === 'serie');
          setContenidos(prev => ({ ...prev, masVistas: { peliculas, series } }));
        } else if (categoria === 'infantiles') {
          response = await api.get(`/noticias/emby/infantiles/${servidorUsuario.toLowerCase()}`);
          setContenidos(prev => ({ ...prev, infantiles: response.data }));
        }
      } catch (err) {
        console.error(err);
        setError('No se pudieron cargar los contenidos. Intente más tarde.');
      } finally {
        setLoading(false);
      }
    };
    if (servidorUsuario) cargarContenidos();
  }, [categoria, servidorUsuario]);

  // Precarga detalles TMDB para todos los "ultimos"
  useEffect(() => {
    if (contenidos.ultimos.length === 0) return;
    contenidos.ultimos.forEach(async (item) => {
      const tipo = item.tipo === 'serie' || item.tipo === 'series' ? 'serie' : 'pelicula';
      await fetchDetallesTMDB(item.tmdb_id, tipo);
    });
  }, [contenidos.ultimos]);

  // Paginación para "ultimos"
  const ultimosFiltrados = contenidos.ultimos.filter(item => {
    const tipo = (item.tipo || '').toLowerCase().trim();
    return subCategoriaRecientes === 'peliculas'
      ? ['pelicula', 'movie'].includes(tipo)
      : ['serie', 'series', 'tv', 'episode'].includes(tipo);
  });
  
  const totalItems = ultimosFiltrados.length;
  const totalPaginas = Math.ceil(totalItems / itemsPerPage);

  const handlePaginaAnterior = () => {
    if (paginaActual > 1) setPaginaActual(paginaActual - 1);
  };

  const handlePaginaSiguiente = () => {
    if (paginaActual < totalPaginas) setPaginaActual(paginaActual + 1);
  };

  const contenidosPaginaActual = ultimosFiltrados.slice(
    (paginaActual - 1) * itemsPerPage,
    paginaActual * itemsPerPage
  );

  const abrirDetalles = async (item) => {
    const tipoApi = item.tipo === 'serie' || item.tipo === 'series' ? 'serie' : 'pelicula';
    const detallesTMDB = await fetchDetallesTMDB(item.tmdb_id, tipoApi);
    setModalData({ ...item, detallesTMDB, tipo: tipoApi === 'pelicula' ? 'Película' : 'Serie' });
  };

  const cerrarModal = () => setModalData(null);

  const renderCard = (item) => {
    const posterUrl =
      item.caratula ||
      (detallesCache[item.tmdb_id]?.poster_path
        ? `https://image.tmdb.org/t/p/w600_and_h900_bestv2${detallesCache[item.tmdb_id].poster_path}`
        : null) ||
      placeholderImage;

    return (
      <div 
        key={item.id} 
        className="card" 
        onClick={() => abrirDetalles(item)}
        onMouseEnter={() => setHoveredCard(item.id)}
        onMouseLeave={() => setHoveredCard(null)}
      >
        <div className="card-image">
          <img
            src={posterUrl}
            alt={item.titulo || 'Sin título'}
            onError={e => {
              e.target.onerror = null;
              e.target.src = placeholderImage;
            }}
          />
        </div>
        <div className="card-info">
        <h3 className="card-title">
  {detallesCache[item.tmdb_id]?.title || detallesCache[item.tmdb_id]?.name || item.titulo || 'Sin título'}
</h3>
{detallesCache[item.tmdb_id]?.release_date || detallesCache[item.tmdb_id]?.first_air_date ? (
  <div className="anio">
    {new Date(detallesCache[item.tmdb_id].release_date || detallesCache[item.tmdb_id].first_air_date).getFullYear()}
  </div>
) : null}



  {/* Año para películas */}
  {item.tipo === 'pelicula' && detallesCache[item.tmdb_id]?.release_date && (
    <div className="anio-lanzamiento">
      {new Date(detallesCache[item.tmdb_id].release_date).getFullYear()}
    </div>
  )}

  {/* Temporada y episodio para series */}
  {item.tipo?.includes('serie') && item.temporada != null && (
    <div className="temporada">Temporada {item.temporada}</div>
  )}
  {item.tipo?.includes('serie') && item.episodio != null && (
    <div className="episodio">Episodio {item.episodio}</div>
  )}
</div>

        
        {hoveredCard === item.id && (item.descripcion || item.descripcion_episodio) && (
          <div className="card-synopsis">
            <p>{item.descripcion_episodio || item.descripcion}</p>
          </div>
        )}
      </div>
    );
  };

  const renderListado = (items) => (
    <div className="grid">{items.length > 0 ? items.map(renderCard) : <div className="empty-message">No hay contenidos disponibles</div>}</div>
  );

  if (loading) return <div className="loading">Cargando contenidos...</div>;
  if (error) return <div className="error">{error}</div>;

  return (
    <>
      {/* Menús fijos */}
      <div style={{ position: 'fixed', top: '10px', right: '10px', zIndex: 2001 }}>
        <AjustesMenu />
      </div>
      <div style={{ position: 'fixed', top: '10px', left: '10px', zIndex: 2000 }}>
        <UserMenu />
      </div>
    <div className="perfil-noticias">
      <h2>Contenidos en {nombresServidores[servidorUsuario] || servidorUsuario}</h2>

      <div className="tabs">
        <button className={categoria === 'ultimos' ? 'active' : ''} onClick={() => setCategoria('ultimos')}>
          Recientes
        </button>
        <button className={categoria === 'masVistas' ? 'active' : ''} onClick={() => setCategoria('masVistas')}>
          Más Vistos
        </button>
        <button className={categoria === 'infantiles' ? 'active' : ''} onClick={() => setCategoria('infantiles')}>
          Infantiles
        </button>
      </div>

      {categoria === 'ultimos' && (
        <>
          <h3>Últimos añadidos</h3>
          <p style={{ color: '#bbb', marginBottom: '10px' }}>
  Servidor actual: <strong>{nombresServidores[servidorUsuario] || servidorUsuario}</strong>
</p>

          <div className="subtabs">
            <button className={subCategoriaRecientes === 'peliculas' ? 'active' : ''} onClick={() => setSubCategoriaRecientes('peliculas')}>
              Películas
            </button>
            <button className={subCategoriaRecientes === 'series' ? 'active' : ''} onClick={() => setSubCategoriaRecientes('series')}>
              Series
            </button>
          </div>

          {renderListado(contenidosPaginaActual)}

          {totalPaginas > 1 && (
            <div className="pagination">
              <button onClick={handlePaginaAnterior} disabled={paginaActual === 1}>
                ← Anterior
              </button>
              <span>
                Página {paginaActual} de {totalPaginas}
              </span>
              <button onClick={handlePaginaSiguiente} disabled={paginaActual === totalPaginas}>
                Siguiente →
              </button>
            </div>
          )}
        </>
      )}

      {categoria === 'masVistas' && (
        <>
          <h3>Películas más vistas</h3>
          {renderListado(contenidos.masVistas.peliculas)}
          <h3>Series más vistas</h3>
          {renderListado(contenidos.masVistas.series)}
        </>
      )}

      {categoria === 'infantiles' && (
        <>
          <h3>Contenido infantil</h3>
          {renderListado(contenidos.infantiles)}
        </>
      )}

      {modalData && (
        <div className="modal-overlay" onClick={cerrarModal}>
          <div className="modal-content" onClick={e => e.stopPropagation()}>
            <button className="close-button" onClick={cerrarModal}>×</button>

            <div className="modal-header">
              <img
                src={
                  modalData.detallesTMDB?.poster_path
                    ? `https://image.tmdb.org/t/p/w500${modalData.detallesTMDB.poster_path}`
                    : modalData.caratula || placeholderImage
                }
                alt={modalData.titulo}
              />
              <div className="modal-title">
                <h2>{modalData.titulo}</h2>
                {modalData.temporada != null && modalData.episodio != null && (
  <div className="episode-title">
    <span>Temporada {modalData.temporada}</span>
    <span>Episodio {modalData.episodio}</span>
  </div>
)}

              </div>
            </div>

            <div className="modal-body">
              {modalData.descripcion_episodio && (
                <>
                  <h4>Sinopsis del episodio:</h4>
                  <p>{modalData.descripcion_episodio}</p>
                </>
              )}
              <h4>Sinopsis {modalData.tipo === 'Película' ? 'de la película' : 'de la serie'}:</h4>
              <p>{modalData.detallesTMDB?.overview || modalData.descripcion || 'Descripción no disponible'}</p>

              <div className="details-grid">
                <div>
                  <h4>Género</h4>
                  <p>{modalData.detallesTMDB?.genres?.map(g => g.name).join(', ') || modalData.genero || 'Desconocido'}</p>
                </div>
                <div>
                  <h4>Reparto</h4>
                  <p>{modalData.detallesTMDB?.credits?.cast?.slice(0, 5).map(a => a.name).join(', ') || 'No disponible'}</p>
                </div>
                <div>
                  <h4>Servidor</h4>
                  <p>{modalData.servidor}</p>
                </div>
              </div>

              <div className="modal-actions">
                <a
                  href={construirUrlEmby(modalData.emby_id, modalData.servidor)}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="btn-ver-emby"
                >
                  ▶ Ver en Emby
                </a>
              </div>
            </div>
          </div>
        </div>
      )}

      <style>{`
        .perfil-noticias {
          padding: 20px;
          color: white;
        }
        .loading,
        .error {
          padding: 40px;
          text-align: center;
          font-size: 1.2rem;
        }
        .error {
          color: #ff6b6b;
        }
        .tabs {
          display: flex;
          gap: 10px;
          margin: 20px 0;
        }
        .tabs button {
          padding: 10px 20px;
          background: #333;
          color: white;
          border: none;
          border-radius: 6px;
          cursor: pointer;
          transition: all 0.3s;
        }
        .tabs button.active {
          background: #00c853;
          color: black;
          font-weight: bold;
        }
        .subtabs {
          display: flex;
          gap: 10px;
          margin: 10px 0 20px;
        }
        .subtabs button {
          padding: 8px 18px;
          background: #444;
          color: white;
          border: none;
          border-radius: 6px;
          cursor: pointer;
          transition: all 0.3s;
        }
        .subtabs button.active {
          background: #0091ea;
          color: white;
          font-weight: bold;
        }
        .grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(140px, 1fr));
  gap: 20px;
  margin-top: 15px;
}

        .card {
          width: 140px;
          background: #1e1e1e;
          border-radius: 8px;
          overflow: hidden;
          cursor: pointer;
          transition: transform 0.3s;
          position: relative;
          z-index: 0;
        }
        .card:hover {
          transform: scale(1.5);
          z-index: 10;
          box-shadow: 0 10px 20px rgba(0,0,0,0.8);
        }
        .card-image {
          position: relative;
          padding-top: 150%;
          overflow: hidden;
        }
        .card-image img {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
        .card-info {
          padding: 12px;
          display: flex;
          flex-direction: column;
          gap: 4px;
        }
        .card-title {
          margin: 0;
          font-size: 0.85rem;
          line-height: 1.2;
          word-break: break-word;
          display: -webkit-box;
          -webkit-line-clamp: 3;
          -webkit-box-orient: vertical;
          overflow: hidden;
          min-height: 2.8em;
        }
        .temporada, .episodio, .nombre-episodio {
          font-size: 0.75rem;
          color: #aaa;
          line-height: 1.2;
        }
        .nombre-episodio {
          font-style: italic;
          margin-top: 2px;
        }
        .card-synopsis {
          position: absolute;
          top: 100%;
          left: 0;
          right: 0;
          background: rgba(30, 30, 30, 0.95);
          padding: 12px;
          font-size: 0.8rem;
          line-height: 1.4;
          z-index: 20;
          border-bottom-left-radius: 8px;
          border-bottom-right-radius: 8px;
          max-height: 200px;
          overflow-y: auto;
        }
        .empty-message {
          grid-column: 1 / -1;
          text-align: center;
          padding: 40px;
          color: #777;
        }
        .pagination {
          display: flex;
          justify-content: center;
          align-items: center;
          gap: 20px;
          margin: 20px 0;
        }
        .pagination button {
          padding: 8px 16px;
          background: #333;
          color: white;
          border: none;
          border-radius: 4px;
          cursor: pointer;
        }
        .pagination button:disabled {
          opacity: 0.5;
          cursor: not-allowed;
        }
        .modal-overlay {
          position: fixed;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: rgba(0, 0, 0, 0.8);
          display: flex;
          align-items: center;
          justify-content: center;
          z-index: 1000;
          padding: 20px;
        }
        .modal-content {
          background: #222;
          border-radius: 12px;
          max-width: 800px;
          width: 100%;
          max-height: 90vh;
          overflow-y: auto;
          position: relative;
        }
        .close-button {
          position: absolute;
          top: 15px;
          right: 15px;
          background: #ff4444;
          border: none;
          color: white;
          width: 30px;
          height: 30px;
          border-radius: 50%;
          font-size: 1.2rem;
          cursor: pointer;
          z-index: 10;
        }
        .modal-header {
          position: relative;
          display: flex;
          align-items: flex-end;
          min-height: 300px;
        }
        .modal-header img {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          object-fit: cover;
          z-index: 1;
        }
        .modal-header::after {
          content: '';
          position: absolute;
          bottom: 0;
          left: 0;
          right: 0;
          height: 100%;
          background: linear-gradient(to top, rgba(0, 0, 0, 0.9), transparent);
          z-index: 2;
        }
        .modal-title {
          position: relative;
          z-index: 3;
          padding: 20px;
          width: 100%;
        }
        .modal-title h2 {
          margin: 0;
          font-size: 1.8rem;
        }
        .modal-title .episode-title {
          display: flex;
          gap: 12px;
          margin: 8px 0;
          font-size: 1rem;
          color: #ddd;
          flex-wrap: wrap;
        }
        .modal-title .episode-title .episode-name {
          font-style: italic;
          color: #bbb;
        }
        .modal-body {
          padding: 20px;
        }
        .modal-body h4 {
          color: #00c853;
          margin: 15px 0 5px 0;
          font-size: 1rem;
        }
        .modal-body p {
          line-height: 1.6;
          margin-bottom: 20px;
        }
        .details-grid {
          display: grid;
          grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
          gap: 20px;
          margin: 20px 0;
        }
        .details-grid h4 {
          margin: 0 0 5px 0;
          color: #00c853;
        }
        .details-grid p {
          margin: 0;
          color: #ccc;
        }
        .modal-actions {
          text-align: center;
          margin-top: 20px;
        }
        .btn-ver-emby {
          display: inline-block;
          background: #00c853;
          color: black;
          padding: 10px 20px;
          border-radius: 6px;
          font-weight: bold;
          text-decoration: none;
          cursor: pointer;
          transition: background-color 0.3s ease;
        }
        .btn-ver-emby:hover {
          background: #00b045;
          color: white;
        }
        @media (max-width: 768px) {
          .grid {
            grid-template-columns: repeat(auto-fill, minmax(120px, 1fr));
          }
          .modal-header {
            min-height: 200px;
          }
          .modal-title h2 {
            font-size: 1.4rem;
          }
          .card-title {
            font-size: 0.75rem;
            -webkit-line-clamp: 2;
          }
          .temporada, .episodio, .nombre-episodio {
            font-size: 0.7rem;
          }
        }
          .anio-lanzamiento {
  font-size: 0.75rem;
  color: #ccc;
}

      `}</style>
    </div>
    </>
  );
}

export default PerfilNoticias;